import { useState, useEffect } from 'react'

import { DatasetSelect } from './dataset-select'
import { SubgroupEdit } from './subgroup-edit'
import { DataFieldSelect } from './data-field-select'
import { SUBGROUP_COLUMN } from './report-data-set.constants'
import { usePageEditorContext } from '../contexts/page-editor.context'
import { DataFieldSwitch } from './data-field-switch'
import { REPORT_VIEWERS } from '../constants'

export const DatasetFieldsEditor = function ({
  block,
  datasetOptions,
  isDatasetKeyValid,
  handleDataSetChange,
  dataFields = [],
  dataFieldOptions = [],
  handleDataFieldChange = () => {},
  handleSplitChartChange = () => {},
  subgroupColumns,
  additionalFields,
  showSplitChartOption = false
}) {
  const { page } = usePageEditorContext() || {}
  const [splitChart, setSplitChart] = useState(block.props.splitChart)
  const [columns, setColumns] = useState(showSplitChartOption ? [...subgroupColumns, SUBGROUP_COLUMN.SPLIT_FILTER] : subgroupColumns)

  // Set showSpltChartOption to false if this is an executive summary page
  if (page && page.viewer === REPORT_VIEWERS.EXECUTIVE_SUMMARY_PAGE) {
    showSplitChartOption = false
  }

  useEffect(() => {
    // Update columns whenever splitChart option changes
    if (showSplitChartOption && block.props.splitChart) {
      setColumns([...subgroupColumns, SUBGROUP_COLUMN.SPLIT_FILTER])
    } else {
      setColumns(subgroupColumns)
    }
  }, [showSplitChartOption, block.props.splitChart])

  // Reformat subgroup columns for non-interactive pages
  if (!page.isInteractive) {
    const hasStrata = !!subgroupColumns.find((subgroup) => subgroup === SUBGROUP_COLUMN.STRATA)
    subgroupColumns.length = 0
    subgroupColumns.push(SUBGROUP_COLUMN.FILTERS)
    if (hasStrata) {
      subgroupColumns.unshift(SUBGROUP_COLUMN.STRATA)
    }
  }

  const dataDefinition = block && block.props && block.props.dataDefinition

  function handleDataFieldSelectChange (key, newValue) {
    dataDefinition[key] = newValue
    handleDataFieldChange(key, newValue)
  }

  function updateSplitChart (splitChart) {
    block.props.splitChart = splitChart
    setSplitChart(splitChart)
    handleSplitChartChange(splitChart)
  }

  return (
    <div className="edit-container">
      <div className="select-fields">
        <DatasetSelect label={'DataSet'} selectedValue={block.dataKey} options={datasetOptions} isValid={isDatasetKeyValid} onChange={handleDataSetChange} />
        {isDatasetKeyValid &&
          dataFields.slice(0, 2).map(([key, label, isRequired]) => (
            <div data-qa={`select-field-${key}`} key={key}>
              <DataFieldSelect data-qa={`select-field-${key}`} selectedValue={dataDefinition[key]} dataFieldOptions={dataFieldOptions} dataKey={key} label={label} isRequired={isRequired} onChange={handleDataFieldSelectChange} />
            </div>
          ))
        }
        {!((isDatasetKeyValid && dataFields.slice(2).length) || additionalFields) && showSplitChartOption && <DataFieldSwitch dataKey="split-chart" selectedValue={splitChart} onChange={updateSplitChart} label="Split Chart" />}
      </div>
      <div className="select-fields">
        {isDatasetKeyValid &&
          dataFields.slice(2).map(([key, label, isRequired]) => (
            <DataFieldSelect key={key} selectedValue={dataDefinition[key]} dataFieldOptions={dataFieldOptions} dataKey={key} label={label} isRequired={isRequired} onChange={handleDataFieldSelectChange} />
          ))
        }
        {additionalFields && additionalFields}
        {!!((isDatasetKeyValid && dataFields.slice(2).length) || additionalFields) && showSplitChartOption && <DataFieldSwitch dataKey="split-chart" selectedValue={splitChart} onChange={updateSplitChart} label="Split Chart" />}
      </div>
      {isDatasetKeyValid && (
        <SubgroupEdit columns={columns} />
      )}
    </div>
  )
}

export const DatasetEmptyState = function ({ block, dataSetOptions, isDatasetKeyValid, handleDataSetChange }) {
  return (
    <div className="report-editor-inline">
      <div className="flex-center-items edit-container">
        <p>To get started, first select a dataset.</p>
        <DatasetSelect selectedValue={block.dataKey} options={dataSetOptions} isValid={isDatasetKeyValid} onChange={handleDataSetChange} />
      </div>
    </div>
  )
}
